import React from 'react';
import Layout from '../components/Layout';


const ConfigPage = () => {
  return (
    <Layout mode="container">
      <h1 className="title is-1">Paramètres</h1>
      <p>Pour l'instant pas grand chose.</p>
    </Layout>
  );
};

export default ConfigPage;